import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Local dev safety: never silently point at production when env vars are missing.
// This also avoids mismatches where the UI token is minted for one Supabase project,
// but backend services (Railway) validate/authorize against another.
const DEFAULT_STAGING_SUPABASE_URL = 'https://hrqusulspzgtgbycxjrf.supabase.co';
const DEFAULT_STAGING_SUPABASE_KEY = 'sb_publishable_rB_NAoIy0AhqQlkcawr-bA_vkggFbYr';

// Use environment variables to support different environments (staging, production).
// If unset:
// - DEV builds default to staging (safer)
// - PROD builds require explicit env vars
const envUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const envKey = (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_SUPABASE_ANON_KEY) as string | undefined;

if (envUrl && !envKey) {
  // Fail fast: a mismatched URL+key combo causes confusing auth failures.
  throw new Error(
    'Missing Supabase key: set VITE_SUPABASE_PUBLISHABLE_KEY (preferred) or VITE_SUPABASE_ANON_KEY when VITE_SUPABASE_URL is set.'
  );
}

export const SUPABASE_URL =
  envUrl || (import.meta.env.DEV ? DEFAULT_STAGING_SUPABASE_URL : (() => { throw new Error('VITE_SUPABASE_URL is required in production builds'); })());
export const SUPABASE_PUBLISHABLE_KEY =
  envKey || (import.meta.env.DEV ? DEFAULT_STAGING_SUPABASE_KEY : (() => { throw new Error('VITE_SUPABASE_PUBLISHABLE_KEY is required in production builds'); })());

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
